import styled from 'styled-components';


export const DropdownContent = styled.div`
  width: ${({ width }) => width || 170}px;
  border-radius: 2px;
`;

export const DropdownList = styled.ul`
  list-style-type: none;
  margin: 0;
  padding: 0;
`;

export const DropdownItem = styled.li`
  min-height: 38px;
  line-height: 1.5;
  display: flex;
  align-items: center;

  a {
    display: flex;
    align-items: center;
    height: 38px;
    width: 100%;
    padding: 0 10px;
    color: ${({ theme }) => theme.colors.fontSilverPrimary};
  }
  
  button {
    height: 38px;
    width: 100%;
    padding: 0 10px;
    text-align: left;
    outline: none;
  }
  
  &:hover {
    cursor: pointer;
    background-color: ${({ theme }) => theme.colors.backgroundGray};

    &:first-child {
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
    }

    &:last-child {
      border-bottom-right-radius: 4px;
      border-bottom-left-radius: 4px;
    }
  }
`;

export const DropdownAction = styled.div`
  min-height: 38px;
  width: ${({ width }) => width || '100%'};
  ${({ theme, redColor }) => redColor && `color: ${theme.colors.red}`};
  display: flex;
  align-items: center;
  padding: 0 10px;

  svg {
    display: inline-block;
    margin-right: 8px;
  }
   
  a {
    display: inline-block;
    width: 100%;
    text-decoration: none;
  }
  
  &:hover {
    cursor: pointer;
  }
`;



// WEBPACK FOOTER //
// ./src/components/ui-helpers/dropdown.js